var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,{tag:"component",staticClass:"tooltip-wraper"},[_vm._t("default"),_vm._v(" "),_c('span',{class:("tooltip tooltip--" + (_vm.props.position))},[_vm._v("\n        "+_vm._s(_vm.props.text)+"\n    ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c36a2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/components/Tooltip.vue
// module id = 1883
// module chunks = 0